export default __webpack_public_path__ + "static/non-fiction-d082381a126538cce8e6637bd520a7d2.jpg";